import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchApi } from "../../../utlis/axios";
import Loader from "../../Loader/Loader";
import GetRequest from "../overtime/GetRequest";
import OfftimeGet from "../offtime/OfftimeGet";
import noFile from "../../../assets/noFile.png";
import CompanyTimeoffs from "./CompanyTimeoffs";
import AdminTimeSheet from "../timesheet/AdminTimeSheet";
import CompanyTemplates from "../template/CompanyTemplates";
import { useNavigate } from "react-router-dom";
import RegCompany from "./CompanyForm";
import { addToast } from "../../../Redux/Slices/toast-slice";
import { FaBuildingCircleExclamation } from "react-icons/fa6";
import { LuCalendarX2 } from "react-icons/lu";
import { LuFileSpreadsheet } from "react-icons/lu";
import { LiaUserClockSolid } from "react-icons/lia";
import { MdMoreTime } from "react-icons/md";
import { FiMenu } from "react-icons/fi";
import { FaChevronLeft, FaChevronRight, FaRegEdit } from "react-icons/fa";

const UpdateCompany = () => {
  const { userInfo, companyInfo } = useSelector((state) => state?.auth || {});
  const { theme } = useSelector((state) => state?.theme);
  const dispatch = useDispatch();
  const [companyData, setCompanyData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState({
    name: "",
    site_url: "",
    logo: [],
    stamp: [],
    address: "",
    postal_code: "",
    city: "",
    state: "",
    country: "",
    owner: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);
  const tabsRef = useRef([]);
  const underlineRef = useRef(null);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (files?.length > 0) {
      setFormValues({ ...formValues, [name]: files[0] });
    } else {
      setFormValues({ ...formValues, [name]: value });
    }
  };

  const handleFileChange = (field) => (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const fileDataURL = reader.result;
        setCompanyData((prev) => ({
          ...prev,
          [field]: fileDataURL,
        }));
        setFormValues((prev) => ({
          ...prev,
          [field]: file,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleMouseEnter = () => {
    if (window.innerWidth >= 768) {
      setSidebarOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (window.innerWidth >= 768) {
      setSidebarOpen(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setMobileSidebarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (tabsRef.current[activeTab] && underlineRef.current) {
      const activeButton = tabsRef.current[activeTab];
      underlineRef.current.style.width = `${activeButton.offsetWidth}px`;
      underlineRef.current.style.left = `${activeButton.offsetLeft}px`;
    }
  }, [activeTab, sidebarOpen]);

  let isFetched = false;
  const getCompanyData = async () => {
    if (isFetched) return;
    isFetched = true;
    if (userInfo?.company) {
      try {
        setIsLoading(true);
        const res = await fetchApi.get(`companies/${userInfo.company.id}`, {
          headers: {
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        });
        if (res.status === 200) {
          const company = res.data;
          setCompanyData(company);
          setFormValues({
            name: company?.name || "",
            site_url: company?.site_url || "",
            logo: [],
            stamp: [],
            address: company?.address || "",
            postal_code: company?.postal_code || "",
            city: company?.city || "",
            state: company?.state || "",
            country: company?.country || "",
            owner: company?.owner || "",
          });
          setIsLoading(false);
        } else {
          dispatch(addToast({ message: 'Something went wrong', type: 'error' }));
          setIsLoading(false);
        }
      } catch (err) {
        console.log(err);
        dispatch(addToast({ message: 'Error fetching company data', type: 'error' }));
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    getCompanyData();
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);

    const updatedValues = {};

    for (let key in formValues) {
      if (key === "logo" || key === "stamp") {
        if (formValues[key] instanceof File) {
          updatedValues[key] = formValues[key];
        }
      } else if (
        formValues[key] !== companyData[key] &&
        formValues[key] !== undefined
      ) {
        updatedValues[key] = formValues[key];
      }
    }

    if (Object.keys(updatedValues).length === 0) {
      setLoading(false);
      dispatch(addToast({ message: 'No changes made', type: 'warn' }));
      return;
    }

    const formData = new FormData();
    for (let key in updatedValues) {
      formData.append(key, updatedValues[key]);
    }

    try {
      const res = await fetchApi.patch(
        `companies/${companyData.id}/`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${userInfo.access_token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.status === 200) {
        setCompanyData(res.data);
        dispatch(addToast({ message: 'Company detail updated successfully', type: 'success' }));
      }
    } catch (error) {
      console.error("Error updating company details:", error);
      dispatch(addToast({ message: 'Failed to update company data please try again', type: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  const tabs = [
    { label: "Company Info", value: "1", icon: <FaBuildingCircleExclamation className="w-6 h-6" /> },
    { label: "Company Timeoffs", value: "2", icon: <LuCalendarX2 className="w-6 h-6" /> },
    { label: "Overtime", value: "3", icon: <MdMoreTime className="w-6 h-6" /> },
    { label: "Timeoffs", value: "4", icon: <LiaUserClockSolid className="w-6 h-6" /> },
    { label: "Timesheet", value: "5", icon: <LuFileSpreadsheet className="w-6 h-6" /> },
  ];

  const standardUserTabs = [
    { label: "Company Info", value: "1", icon: <FaBuildingCircleExclamation className="w-6 h-6" /> },
    { label: "Company Timeoffs", value: "2", icon: <LuCalendarX2 className="w-6 h-6" /> },
  ];

  return (
    <div className="w-full flex overflow-hidden relative fontRoboto ">
      {(isLoading || loading) && (
        <>
          <div className="fixed inset-0 bg-black bg-opacity-50 z-10 md:top-[95px] top-[52px]"></div>
          <div className="fixed inset-0 flex items-center justify-center z-20 md:top-[95px] top-[52px]">
            <Loader />
          </div>
        </>
      )}
      <button
        className={`md:hidden fixed top-12 left-0 z-30 p-2 rounded-md ${theme === 'dark' ? 'bg-[#212529] text-white' : 'bg-[#DFDFDF] text-black'}`}
        onClick={() => setMobileSidebarOpen(!mobileSidebarOpen)}
      >
       {mobileSidebarOpen ? <FaChevronLeft className="w-6 h-6" /> : <FaChevronRight className="w-6 h-6" />}
      </button>

      <div
        ref={sidebarRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className={`fixed z-20 md:h-[87vh] h-[92vh]  transition-all duration-300 ease-in-out ${mobileSidebarOpen ? "left-0" : "-left-full md:left-0"
          } ${sidebarOpen ? "" : ""
          } ${theme === 'dark' ? 'bg-[#212529] text-white' : 'bg-[#DFDFDF] text-black'}`}
      >
        <div className="flex flex-col items-center gap-4 py-8 px-4 h-full overflow-y-auto">

          {(userInfo?.user?.plan?.name === "Standard" ? standardUserTabs : tabs).map((tab, index) => (
            <button
              key={index}
              ref={(el) => (tabsRef.current[index] = el)}
              onClick={() => {
                if (userInfo.company) {
                  setActiveTab(index);
                  if (window.innerWidth < 768) setMobileSidebarOpen(false);
                } else {
                  dispatch(addToast({ message: 'You need to create company first', type: 'error' }));
                }
              }}
              className={`flex items-center  gap-3 py-2  text-lg font-medium ${sidebarOpen ? 'rounded-[16px] justify-start px-4' : 'rounded-[10px] px-2 justify-center'} w-full outline-none transition-colors ${activeTab === index
                  ? "text-white bg-gradient-to-r from-[#CC0927] to-[#7E0105]"
                  : theme === "light"
                    ? "text-gray-800 hover:bg-gradient-to-r hover:from-[#6d6d6d33] hover:to-[#fff0] transition-all"
                    : "text-white hover:bg-gradient-to-r hover:from-[#fff3] hover:to-[#fff0] transition-all"
                }`}
            >
              <span className="flex-shrink-0">{tab.icon}</span>
              <span className={`${sidebarOpen ? '' : 'hidden'} transition-opacity duration-200`}>
                {tab.label}
              </span>
            </button>
          ))}
        </div>
      </div>

      <div className={`flex flex-col items-center h-full w-full overflow-y-auto transition-margin duration-300 ${mobileSidebarOpen ? '' : ' '
        } ${sidebarOpen  ? !mobileSidebarOpen ?  'md:ml-64' : '' : !mobileSidebarOpen ? 'md:ml-[87px]' : ''}`}>
        {activeTab === 0 ? (
          <div className={`flex flex-col justify-center items-center w-full p-4`}>
            {!userInfo.company ? (
              <div className="w-full flex items-start">
                <button
                  className="my-4 heroButton"
                  onClick={() => setIsOpen(true)}
                >
                  Create Company
                </button>
              </div>
            ) : (
              <>
                <h2 className={`main-heading text-center mt-4 ${theme === "light" ? "text-black" : "text-white"}`}>
                  Update Your Company Data
                </h2>
                <div className={`signup-box max-w-[768px] w-full mt-4 border fontPoppins  rounded-[16px] ${theme === "dark"
                    ? "text-white bg-[#1E1E1E] shadow-2xl border-[#555657]"
                    : "text-black bg-white shadow-2xl border-[#D8D8D8]"
                  }`} style={{boxShadow: '0px 0px 4.7px 0px #00000040',borderRadius:'20px'                  }}>
                  <form onSubmit={handleUpdate} className="p-6">
                  <div className="grid sm:grid-cols-2 grid-cols-1 gap-4 mt-4">
                      <div className="input-group flex flex-col items-center ">
                       
                        {companyData.logo ? (
                          <>
                            <img
                              src={companyData.logo}
                              alt="Logo Preview"
                              className="w-16 h-16 object-cover rounded-full"
                            />
                            <button
                              type="button"
                              onClick={() => {
                                const fileInput =
                                  document.getElementById("logo-file-input");
                                if (fileInput) fileInput.click();
                              }}
                              className={`relative top-[-30px] left-[52px] rounded-full p-1 ${theme === 'dark' ? 'bg-[#212529] ':'bg-white'}`}
                            >
                              <FaRegEdit className="w-5 h-5 text-red-600"/>
                            </button>
                            <input
                              type="file"
                              id="logo-file-input"
                              name="logo"
                              onChange={handleFileChange("logo")}
                              className="hidden"
                            />
                          </>
                        ) : (
                          <>
                            <img
                              src={noFile}
                              alt="no file selected"
                              className="w-16 h-16 object-cover rounded-full"
                            />
                            <button
                              type="button"
                              onClick={() => {
                                const fileInput =
                                  document.getElementById("logo-file-input");
                                if (fileInput) fileInput.click();
                              }}
                              className={`relative top-[-30px] left-[52px] rounded-full p-1 ${theme === 'dark' ? 'bg-[#212529] ':'bg-white'}`}
                            >
                            <FaRegEdit className="w-5 h-5 text-red-600"/>
                            </button>
                            <input
                              type="file"
                              id="logo-file-input"
                              name="logo"
                              onChange={handleFileChange("logo")}
                              className="hidden"
                            />
                          </>
                        )}
                         <label className="input-label" style={{fontSize:'18px'}}>Logo</label>
                      </div>

                      <div className="input-group flex flex-col items-center">
                       
                        {companyData.stamp ? (
                          <>
                            <img
                              src={companyData.stamp}
                              alt="Stamp Preview"
                              className="w-16 h-16 object-cover rounded-full"
                            />
                            <button
                              type="button"
                              onClick={() => {
                                const fileInput =
                                  document.getElementById("stamp-file-input");
                                if (fileInput) fileInput.click();
                              }}
                              className={`relative top-[-30px] left-[52px] rounded-full p-1 ${theme === 'dark' ? 'bg-[#212529] ':'bg-white'}`}
                            >
                              <FaRegEdit className="w-5 h-5 text-red-600"/>
                            </button>
                            <input
                              type="file"
                              id="stamp-file-input"
                              name="stamp"
                              onChange={handleFileChange("stamp")}
                              className="hidden"
                            />
                          </>
                        ) : (
                          <>
                            <img
                              src={noFile}
                              alt="no file selected"
                              className="w-16 h-16 object-cover rounded-full"
                            />
                            <button
                              type="button"
                              onClick={() => {
                                const fileInput =
                                  document.getElementById("stamp-file-input");
                                if (fileInput) fileInput.click();
                              }}
                              className={`relative top-[-30px] left-[52px] rounded-full p-1 ${theme === 'dark' ? 'bg-[#212529] ':'bg-white'}`}
                            >
                              <FaRegEdit className="w-5 h-5 text-red-600"/>
                            </button>
                            <input
                              type="file"
                              id="stamp-file-input"
                              name="stamp"
                              onChange={handleFileChange("stamp")}
                              className="hidden"
                            />
                          </>
                        )}
                         <label className="input-label" style={{fontSize:'18px'}}>Stamp</label>
                      </div>
                    </div>
                    <div className="grid sm:grid-cols-2 grid-cols-1 gap-4">
                      <div className="input-group">
                        <label className="input-label flex" style={{fontSize:'18px'}}>Name<span className="text-red-600">*</span></label>
                        <input
                          type="text"
                          name="name"
                          value={formValues.name}
                          readOnly
                          placeholder="Enter company name"
                          className={`bg-transparent w-full p-2 border rounded-[10px] ${theme === "dark"
                              ? "text-white border-gray-400"
                              : "text-black border-gray-600"
                            }`}
                        />
                      </div>
                      <div className="input-group">
                        <label className="input-label flex " style={{fontSize:'18px'}}>Address<span className="text-red-600">*</span></label>
                        <input
                          type="text"
                          name="address"
                          value={formValues.address}
                          onChange={handleChange}
                          placeholder="Enter address"
                          className={`bg-transparent w-full p-2 border rounded-[10px] ${theme === "dark"
                              ? "text-white border-gray-400"
                              : "text-black border-gray-600"
                            }`}
                        />
                      </div>

                      <div className="input-group">
                        <label className="input-label flex " style={{fontSize:'18px'}}>Postal Code<span className="text-red-600">*</span></label>
                        <input
                          type="text"
                          name="postal_code"
                          value={formValues.postal_code}
                          onChange={handleChange}
                          placeholder="Enter postal code"
                          className={`bg-transparent w-full p-2 border rounded-[10px] ${theme === "dark"
                              ? "text-white border-gray-400"
                              : "text-black border-gray-600"
                            }`}
                        />
                      </div>
                      <div className="input-group">
                        <label className="input-label flex" style={{fontSize:'18px'}}>City<span className="text-red-600">*</span></label>
                        <input
                          type="text"
                          name="city"
                          value={formValues.city}
                          onChange={handleChange}
                          placeholder="Enter city"
                          className={`bg-transparent w-full p-2 border rounded-[10px] ${theme === "dark"
                              ? "text-white border-gray-400"
                              : "text-black border-gray-600"
                            }`}
                        />
                      </div>
                      <div className="input-group">
                        <label className="input-label flex" style={{fontSize:'18px'}}>State<span className="text-red-600">*</span></label>
                        <input
                          type="text"
                          name="state"
                          value={formValues.state}
                          onChange={handleChange}
                          placeholder="Enter state"
                          className={`bg-transparent w-full p-2 border rounded-[10px] ${theme === "dark"
                              ? "text-white border-gray-400"
                              : "text-black border-gray-600"
                            }`}
                        />
                      </div>
                      <div className="input-group">
                        <label className="input-label flex " style={{fontSize:'18px'}}>Country<span className="text-red-600">*</span></label>
                        <input
                          type="text"
                          name="country"
                          value={formValues.country}
                          onChange={handleChange}
                          placeholder="Enter country"
                          className={`bg-transparent w-full p-2 border rounded-[10px] ${theme === "dark"
                              ? "text-white border-gray-400"
                              : "text-black border-gray-600"
                            }`}
                        />
                      </div>
                    </div>
                    <div className="input-group mt-4">
                      <label className="input-label" style={{fontSize:'18px'}}>Site URL</label>
                      <input
                        type="text"
                        name="site_url"
                        value={formValues.site_url}
                        onChange={handleChange}
                        placeholder="Enter site URL"
                        className={`bg-transparent w-full p-2 border rounded-[10px] ${theme === "dark"
                            ? "text-white border-gray-400"
                            : "text-black border-gray-600"
                          }`}
                      />
                    </div>
                 
                    <div className="flex justify-center gap-4 mt-6">
                      <button
                        className="heroButton w-1/2"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? "Updating..." : "Update"}
                      </button>
                    </div>
                  </form>
                </div>
              </>
            )}
          </div>
        ) : null}
        {activeTab === 1 ? <CompanyTimeoffs /> : null}
        {activeTab === 2 ? <GetRequest /> : null}
        {activeTab === 3 ? <OfftimeGet /> : null}
        {activeTab === 4 ? <AdminTimeSheet /> : null}
      </div>

      {isOpen && (
        <RegCompany
          isOpen={isOpen}
          setOpen={setIsOpen}
          setCompnayData={setCompanyData}
          updateFormValues={setFormValues}
        />
      )}
    </div>
  );
};

export default UpdateCompany;